var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.229 31.3333C36.229 33.6389 34.9223 35.8186 32.624 37.4603C30.3275 39.1006 27.1047 40.1458 23.4998 40.1458C19.8949 40.1458 16.6722 39.1006 14.3757 37.4603C12.0773 35.8186 10.7707 33.6389 10.7707 31.3333C10.7707 29.0277 12.0773 26.848 14.3757 25.2063C16.6722 23.566 19.8949 22.5208 23.4998 22.5208C27.1047 22.5208 30.3275 23.566 32.624 25.2063C34.9223 26.848 36.229 29.0277 36.229 31.3333Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6453 16.762C14.3376 18.4544 14.3649 20.7235 13.2341 21.8543C12.1033 22.9851 9.83416 22.9578 8.14181 21.2655C6.44945 19.5731 6.42223 17.304 7.55299 16.1732C8.68375 15.0424 10.9529 15.0697 12.6453 16.762Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2923 21.2656C37.6 22.958 35.3308 22.9852 34.2 21.8545C33.0693 20.7237 33.0965 18.4545 34.7888 16.7622C36.4812 15.0698 38.7504 15.0426 39.8811 16.1733C41.0119 17.3041 40.9847 19.5733 39.2923 21.2656Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9283 10.874C21.8248 13.0931 20.9633 15.1925 19.4806 15.7916C17.9979 16.3906 15.9197 15.4789 15.0232 13.2598C14.1266 11.0408 14.9882 8.94134 16.4709 8.3423C17.9536 7.74325 20.0317 8.65495 20.9283 10.874Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5863 13.2601C31.6898 15.4792 29.6116 16.3909 28.1289 15.7918C26.6462 15.1928 25.7847 13.0934 26.6812 10.8743C27.5778 8.65523 29.6559 7.74353 31.1386 8.34258C32.6213 8.94163 33.4829 11.041 32.5863 13.2601Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPet);
export default __webpack_public_path__ + "static/media/Pet.0907c1ee31c8bb9925ddf85d7b2b366d.svg";
export { ForwardRef as ReactComponent };